"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __1 = require("../../");
const group_attack_1 = tslib_1.__importDefault(require("../common/group-attack"));
const skill_1 = require("../../skill");
exports.houkikami_skill1 = {
    no: 1,
    handlers: [],
    passive: false,
    cost: 0,
    name: '蓄力一攻',
    target: skill_1.SkillTarget.ENEMY,
    use(battle, sourceId, selectedId) {
        const at = __1.Attack.build(selectedId, sourceId)
            .rate(1)
            .base((battle, sourceId, targetId) => {
            const target = battle.getEntity(targetId);
            return battle.getComputedProperty(target.entityId, __1.BattleProperties.ATK);
        })
            .limit((battle, sourceId, _) => {
            const source = battle.getEntity(sourceId);
            return battle.getComputedProperty(source.entityId, __1.BattleProperties.ATK) * 1.5;
        })
            .single()
            .normalAttack()
            .end();
        battle.actionAttack(at);
    },
};
exports.houkikami_skill2 = new group_attack_1.default(2, '大扫除', 1.31, 2);
